import { Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { Input } from "@songtradr-one/components-frontend";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { Props } from "./SecretField.Parts";

export const SecretField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  control,
  errors,
  rules,
  label,
  name,
  single,
  disabled,
  placeholder,
  readOnly,
  copyable,
  onBlur,
}: Props<FormFields, FieldName>) => {
  return (
    <FormFieldWrapper
      $single={single}
      name={name}
      error={errors[name] as FieldError}
    >
      <Controller
        name={name}
        control={control}
        rules={{ ...rules }}
        render={({ field }) => {
          const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
            field.onBlur();
            if (onBlur) onBlur(event);
          };

          return (
            <Input
              type="password"
              fullWidth
              value={field.value || ""}
              onChange={(e) => field.onChange(e.target.value)}
              placeholder={placeholder}
              label={label}
              disabled={disabled}
              readOnly={readOnly}
              copyable={copyable}
              name={field.name}
              onBlur={handleBlur}
            />
          );
        }}
      />
    </FormFieldWrapper>
  );
};
